import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/')({
    beforeLoad: ({ params }): never => {
        throw redirect({
            to: '/console/$orgId/configuration/compliance/incidents/general',
            params,
            replace: true,
        });
    },
});
